<template>
  <div class="modal-content starttimedetails">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Start time') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-6" v-if="showModeSelector">
          <div class="form-group" id="modeSelector">
            <label class="mimic-flex-row" for="hourlyStarttime"><input type="radio" name="mode" id="hourlyStarttime" value="hourly" v-model="starttime.mode" /> <i class="fa fa-fw fa-clock-o"></i><span>{{ _('Hourly reservations') }}</span></label>
            <label class="mimic-flex-row" for="dailyStarttime"><input type="radio" name="mode" id="dailyStarttime" value="daily" v-model="starttime.mode" /> <i class="fa fa-fw fa-calendar"></i><span>{{ _('Daily reservations') }}</span></label>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mimic-flex-row">
            <label class="radiolabel">
              <input type="radio" name="dayrange" class="form-control inlineradio" id="allWeek" :value="0" v-model="dayRange" /><span>{{ _('Every weekday') }}</span>
            </label>
          </div>
          <div class="flex-row mimic-flex-row">
            <div class="form-group">
              <input type="radio" name="dayrange" class="form-control inlineradio" id="dayRange" :value="1" v-model="dayRange" />
            </div>
            <div class="form-group">
              <div class="input-group">
                <div class="btn-group daybuttons" id="dayRangeButtons">
                  <label :class="'btn btn-sm ' + (weekdays.includes('1') ? 'btn-success' : 'btn-default')" data-value="1">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="1" /><span>{{ _('mo') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('2') ? 'btn-success' : 'btn-default')" data-value="2">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="2" /><span>{{ _('tu') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('3') ? 'btn-success' : 'btn-default')" data-value="3">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="3" /><span>{{ _('we') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('4') ? 'btn-success' : 'btn-default')" data-value="4">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="4" /><span>{{ _('th') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('5') ? 'btn-success' : 'btn-default')" data-value="5">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="5" /><span>{{ _('fr') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('6') ? 'btn-success' : 'btn-default')" data-value="6">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="6" /><span>{{ _('sa') }}</span>
                  </label> 
                  <label :class="'btn btn-sm ' + (weekdays.includes('7') ? 'btn-success' : 'btn-default')" data-value="7">
                    <input type="checkbox" autocomplete="off" v-model="weekdays" value="7" /><span>{{ _('su') }}</span>
                  </label>
                </div> 
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col-md-6 form-inline">
          <div class="form-group mimic-flex-row">
            <label class="radiolabel">
              <input type="radio" name="daterange" class="form-control inlineradio" id="allYear" :value="0" checked="checked" v-model="dateRange"/><span>{{ _('All year') }}</span>
            </label>
          </div>
          <div class="date-range-row">
              <input type="radio" name="daterange" class="form-control inlineradio" id="dateRange" :value="1" v-model="dateRange" />
              <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select start date')"></DatePicker>
              <p class="form-control-static">&nbsp;-&nbsp;</p>
              <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true" :placeholder="_('Select end date')"></DatePicker>
          </div> 
        </div>
        <div class="col-md-6 form-inline">
          <div class="form-group mimic-flex-row">
            <label class="radiolabel" id="atAnyTimeContainer" v-if="isAtAnyTimeVisible">
              <input type="radio" name="timerange" class="form-control inlineradio" id="allDay" :value="0" checked="checked" v-model="timeRange" /><span>{{ _('At any time') }}</span>
            </label>
            <label class="radiolabel" id="startEndTimeTitle" v-else>
              {{ _('Start time - End time') }}
            </label>
          </div>
          <div :class="isAtAnyTimeVisible ? 'date-range-row' : 'date-range-row prefixless'">
            <input type="radio" name="timerange" class="form-control inlineradio" id="startTimeRange" :value="1" v-model="timeRange" v-if="isAtAnyTimeVisible" />
            <TimePicker :shortLocale="shortLocale" v-model="timeStart" :placeholder="_('Select start time')"/>
            <p class="form-control-static" v-if="showEndtimeSelector">&nbsp;-&nbsp;</p>
            <TimePicker :shortLocale="shortLocale" v-model="timeEnd" v-if="showEndtimeSelector" :placeholder="_('Select end time')"/>
          </div>
        </div>
        <div class="col-md-12" style="min-height: 200px">
          <hr>
          <p v-if="isDaily" id="startEndTimeHelper">{{ _('The start time is the time the when the reserved product can be picked up or the customer checks in and the end time is the time when the reserved product should be returned or the customer checks out.') }}</p>
          <template v-else-if="timeStart">
            <h5><i class="fa fa-plus-circle fa-fw"></i> {{ _('Add more start times with these settings') }}</h5>
            <div class="date-range-row">
              <select class="form-control bulk-interval-select" v-model.number="bulkInterval">
                <option :value="15">+15 {{ _('min') }}</option>
                <option :value="30">+30 {{ _('min') }}</option>
                <option :value="45">+45 {{ _('min') }}</option>
                <option :value="60">+60 {{ _('min') }}</option>
                <option :value="90">+90 {{ _('min') }}</option>
                <option :value="120">+120 {{ _('min') }}</option>
              </select>
              <button type="button" class="btn btn-default btn-sm" @click="addBulkTime" :disabled="!canAddBulkTime">
                <i class="fa fa-plus fa-fw"></i> {{ _('Add') }}
              </button>
            </div>
            <div class="bulk-times-list" v-if="bulkTimes.length">
              <span
                v-for="(bt, index) in bulkTimes"
                :key="bt.id"
                class="label label-success bulk-time-chip"
              >
                {{ formatBulkTime(bt.timestart) }}
                <i class="fa fa-times" @click.stop="removeBulkTime(index)"></i>
              </span>
            </div>
          </template>
        </div>
      </div>
      <hr class="routeitem" v-if="isTransportation" />
      <div class="row routeitem" v-if="isTransportation">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ _('If route is') }}</label>
            <select class="form-control" id="route" v-model="starttime.route_id">
              <option value="">{{ _('Select') }}</option>
              <option v-for="route in routes" :value="route.id">{{ route.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" v-on:click="close"><i class="fa fa-close fa-fw"></i> {{ _('Close') }}</button>
      <button type="button" class="btn btn-success" v-on:click="save" :disabled="!isValid"><i class="fa fa-check fa-fw"></i>{{ _('Ok') }}</button>
      <button type="button" class="btn btn-danger pull-left" v-on:click="remove"><i class="fa fa-trash fa-fw"></i>{{ _('Delete') }}</button>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import { DatetimePicker } from '#components'

export default {
  data () {
    return {
      starttime: {},
      bulkStartTime: null,
      bulkEndTime: null,
      bulkInterval: 60,
      bulkTimes: []
    }
  },
  props: ['product', 'origStarttime', 'settings', 'routes'],
  computed: {
    ...mapGetters(['locale', 'dateFormat', 'timeFormat', 'timezone']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    canAddBulkTime () {
      return this.timeRange === 1
    },
    isTransportation () {
      if (!this.product) {
        return false
      }
      const t = this.product.type + '-' + this.product.subtype + '-' + this.product.displayedtype
      return t === '1-3-generic'
    },
    showEndtimeSelector () {
      return this.starttime && this.starttime.mode === 'daily'
    },
    isCalendarPricing () {
      return this.product && this.product.pricing_engine === 'calendar'
    },
    showModeSelector () {
      return !this.isCalendarPricing
    },
    unitTypes () {
      if (!this.product) {
        return []
      }
      // Loop through all pricerows and take each unit type value with map, then return only the unique ones with reduce
      return this.product.ownPricerow.map(p => p.unittype).reduce((u, i) => u.includes(i) ? u : [...u, i], [])
    },
    hasDailyReservations () {
      return this.unitTypes.includes('3') || this.unitTypes.includes(3)
    },
    hasHourlyReservations () {
      return this.unitTypes.includes('1') || this.unitTypes.includes('2')
    },
    isMultiMode () {
      return this.hasDailyReservations && this.hasHourlyReservations
    },
    isHourly () {
      return this.starttime && this.starttime.mode === 'hourly'
    },
    isDaily () {
      return this.starttime && this.starttime.mode === 'daily'
    },
    isAtAnyTimeVisible () {
      return this.isHourly
    },
    dateStart: {
      get() {
        if (!this.starttime || !this.starttime.datestart) {
          return null
        }
        return DateTime.fromFormat(this.starttime.datestart, 'd.M.yyyy', { zone: this.timezone }).toJSDate()

      },
      set(newValue) {
        if (newValue) {
          this.starttime.datestart = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
        } else {
          this.starttime.datestart = null
        }
      }
    },
    dateEnd: {
      get() {
        if (!this.starttime || !this.starttime.dateend) {
          return null
        }
        return DateTime.fromFormat(this.starttime.dateend, 'd.M.yyyy', { zone: this.timezone }).toJSDate()

      },
      set(newValue) {
        if (newValue) {
          this.starttime.dateend = DateTime.fromJSDate(newValue, { zone: this.timezone }).toFormat('d.M.yyyy')
        } else {
          this.starttime.dateend = null
        }
      }
    },
    timeStart: {
      get() {
        if (!this.starttime || (!parseInt(this.starttime.timestart) && parseInt(this.starttime.timestart) !== 0)) {
          return null
        }
        return {
          hours: DateTime.fromFormat(this.convertToTime(this.starttime.timestart), 'H.mm').hour,
          minutes: DateTime.fromFormat(this.convertToTime(this.starttime.timestart), 'H.mm').minute,
          seconds: 0
        }
      },
      set(newValue) {
        if (!newValue) {
          return
        }
        this.starttime.timestart = this.convertToMinutes(DateTime.fromObject({ hour: newValue.hours, minute: newValue.minutes }).toFormat('H.mm'))
      }
    },
    timeEnd: {
      get() {
        if (!this.starttime || (!parseInt(this.starttime.timeend) && parseInt(this.starttime.timeend) !== 0)) {
          return false
        }
        return {
          hours: DateTime.fromFormat(this.convertToTime(this.starttime.timeend), 'H.mm').hour,
          minutes: DateTime.fromFormat(this.convertToTime(this.starttime.timeend), 'H.mm').minute,          
          seconds: 0
        }
      },
      set(newValue) {
        if (!newValue) {
          return
        }
        this.starttime.timeend = this.convertToMinutes(DateTime.fromObject({ hour: newValue.hours, minute: newValue.minutes }).toFormat('H.mm'))
      }
    },
    dayRange: {
      get() {
        if (!this.starttime.weekdays || this.starttime.weekdays === '1,2,3,4,5,6,7') {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.starttime.weekdays = '1,2,3,4,5,6,7'
        }
      }
    },
    dateRange: {
      get() {
        if (!parseInt(this.starttime.datestart) && !parseInt(this.starttime.dateend)) {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.dateStart = null
          this.dateEnd = null
        }
      }
    },
    timeRange: {
      get() {
        if (!parseInt(this.starttime.timestart) && parseInt(this.starttime.timestart) !== 0) {
          return 0
        }
        return 1
      },
      set(newValue) {
        if (newValue === 0) {
          this.timeStart = '0.00'
          this.timeEnd = '24.00'
        }
      }
    },
    weekdays: {
      get() {
        return this.starttime && this.starttime.weekdays && this.starttime.weekdays.split ? this.starttime.weekdays.split(',') : []
      },
      set(newValue) {
        this.starttime.weekdays = newValue.sort().join(',')
      }
    },
    isValid () {
      if (this.starttime) {
        if (this.starttime.mode === 'daily' && ((!this.starttime.timestart && this.starttime.timestart !== 0) || (!this.starttime.timeend && this.starttime.timeend !== 0))) {
          return false
        }
        return true
      }
      return false
    }
  },
  watch: {
    weekdays (newValue, oldValue) {
      if (oldValue.length === 7 && newValue.length === 6) {
        const diff = oldValue.filter(x => !newValue.includes(x))
        nextTick(() => { this.weekdays = diff })
      }
      if (oldValue.length === 1 && newValue.length === 0) {
        nextTick(() => { this.weekdays = [1, 2, 3, 4, 5, 6, 7] })
      }
    }
  },
  methods: {
    closePicker (which) {
      if (this.$refs[which]) {
        this.$refs[which].hidePopover()
      }
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.starttime)
      if (this.bulkTimes.length) {
        const starttimes = this.bulkTimes.map(bt => ({
          ...this.starttime,
          id: bt.id,
          timestart: bt.timestart
        }))
        this.$emit('saveMultiple', starttimes)
      }
    },
    addBulkTime () {
      const lastTime = this.bulkTimes.length
        ? this.bulkTimes[this.bulkTimes.length - 1].timestart
        : this.starttime.timestart
      const nextTime = lastTime + this.bulkInterval
      if (nextTime > 1440) {
        return
      }
      this.bulkTimes.push({
        id: 'new' + new Date().getTime() + '_' + nextTime,
        timestart: nextTime
      })
    },
    removeBulkTime (index) {
      this.bulkTimes.splice(index, 1)
    },
    remove () {
      this.$emit('remove', this.starttime)
    },
    formatBulkTime (timestart) {
      return DateTime.fromFormat(this.convertToTime(timestart), 'H.mm').toFormat(this.timeFormat)
    },
    convertToMinutes (time) {
      if (!time) {
        return 0
      }
      let extraDays = 0
      if (time.match(/\+/)) {
        let extraArr = String(time).split('+')
        time = extraArr[0]
        extraDays = parseInt(extraArr[1], 10)
      }
      let timeArr = String(time).split('.')
      let h = parseInt(timeArr[0], 10)
      let m = parseInt(timeArr[1], 10)
      h += extraDays * 24
      return h * 60 + m
    },
    convertToTime(minutes) {
      let minStr = (minutes % 60)
      if (minStr < 10) {
        minStr = '0' + minStr
      }
      return Math.floor(minutes / 60) + '.' + minStr
    }
  },
  components: {
    DatetimePicker
  },
  created () {
    this.starttime = Object.assign({}, this.origStarttime)
    if (this.isCalendarPricing) {
      this.starttime.mode = 'daily'
    }
  }
}
</script>

<style scoped>
.inlinedate {
  width: 110px !important;
}
.daybuttons input {
  display: none;
}
.bulk-interval-select {
  width: auto;
  display: inline-block;
}
.bulk-times-list {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.bulk-time-chip {
  cursor: pointer;
  font-size: 14px;
  padding: 5px 8px;
  border-radius: 4px;
}
.bulk-time-chip .fa-times {
  margin-left: 5px;
  opacity: 0.7;
}
.bulk-time-chip .fa-times:hover {
  opacity: 1;
}
</style>
<style>
.bootstrap-datetimepicker-widget.dropdown-menu {
  /* width: 10em !important; */
}
</style>